module.exports = __webpack_public_path__ + "static/media/speaker.4f6c2734.png";